'use client';

import { useState, type InputHTMLAttributes } from 'react';

import { designTokens } from '../theme/tokens';

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  const [focusVisible, setFocusVisible] = useState(false);

  return (
    <input
      {...props}
      onBlur={(event) => {
        setFocusVisible(false);
        props.onBlur?.(event);
      }}
      onFocus={(event) => {
        setFocusVisible(event.currentTarget.matches(':focus-visible'));
        props.onFocus?.(event);
      }}
      style={{
        background: designTokens.colors.surfaceContainerLow,
        border: `1px solid ${focusVisible ? designTokens.colors.primary : 'transparent'}`,
        borderRadius: designTokens.radius.base,
        boxShadow: focusVisible ? designTokens.shadows.focusRing : undefined,
        boxSizing: 'border-box',
        color: designTokens.colors.onSurface,
        cursor: props.disabled ? 'not-allowed' : undefined,
        fontFamily: designTokens.font.sans,
        fontSize: designTokens.typography.bodyMd.fontSize,
        lineHeight: designTokens.typography.bodyMd.lineHeight,
        minHeight: 44,
        minWidth: 0,
        opacity: props.disabled ? 0.6 : 1,
        outline: 'none',
        padding: '9px 12px',
        width: '100%',
        ...props.style,
      }}
    />
  );
}
